<template>
    <n-layout has-sider style="height: 100vh">
      <AppSidebar />
      <n-layout>
        <AppHeader />
        <n-layout-content content-style="padding: 1rem;">
          <router-view />
        </n-layout-content>
      </n-layout>
    </n-layout>
  </template>
  
  <script setup>
  import AppHeader from './AppHeader.vue'
  import AppSidebar from './AppSide.vue'
  </script>
  